export default __webpack_public_path__ + "static/media/CNo.77-0.e66342e2.jpg";